import { render, staticRenderFns } from "./SKLoader.vue?vue&type=template&id=597b0116&"
import script from "./SKLoader.vue?vue&type=script&lang=js&"
export * from "./SKLoader.vue?vue&type=script&lang=js&"
import style0 from "./SKLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports